export default __webpack_public_path__ + "static/media/ic_wbnb_40.4fd2e58a.svg";